export default "__VITE_ASSET__U2YcLxa9__"